import utils, { getLabelFallback, getSimplePrescriptionValuesArray } from '@utils/utils';
import PrescriptionSelect from './PrescriptionSelect';
import { isString } from 'lodash';

export type FormTableProps = {
    cylOD;
    cylOS;
    columns;
    formErrors;
    selectPlaceholder;
    selector;
    formValues;
    prescriptionDefaults?;
    isButtonOdOsClicked;
    isButtonSphClicked;
    isButtonCylClicked;
    isButtonAxisClicked;
    isButtonAddClicked;
};

export const FormTableHowToRead = (props: FormTableProps) => {
    const prismSelectPlaceholder = 'None';
    const rightEyeInitials = getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_RIGHT_EYE_INITIALS');
    const leftEyeInitials = getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_LEFT_EYE_INITIALS');
    const rightEyeName = getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_RIGHT_EYE_NAME');
    const leftEyeName = getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_LEFT_EYE_NAME');
    const isAxisDisabled = (id: string) => {
        if (id.indexOf('right') >= 0) {
            return props.cylOD === null || props.cylOD === undefined || props.cylOD === 0;
        } else {
            return props.cylOS === null || props.cylOS === undefined || props.cylOS === 0;
        }
    };

    const disabledAxisLabel = (row: any) => {
        let res = true;
        row.map(el => {
            if (el.id.indexOf('right') >= 0 || el.id.indexOf('left')) {
                return (res =
                    props.cylOD === null || props.cylOD === undefined || props.cylOD === 0);
            }
        });
        return res;
    };

    return (
        <div className={'FullPrescriptionForm__innerContainer__form_table'}>
            <div className={'FullPrescriptionForm__innerContainer__form_leftcol table-headers'}>
                <div className="title-left"></div>
                <div className={'FullPrescriptionForm__innerContainer__form_leftlabel' + (props.isButtonOdOsClicked ? ' border-cell-up' : '')}>
                    <div>{rightEyeInitials} {rightEyeName}</div>
                </div>
                <div className={'FullPrescriptionForm__innerContainer__form_leftlabel' + (props.isButtonOdOsClicked ? ' border-cell-down' : '')}>
                    <div className="left-eye-container">{leftEyeInitials} {leftEyeName}</div>
                </div>
            </div>
            {props.columns.map(col => (
                <div
                    className={
                        'FullPrescriptionForm__innerContainer__form_col' +
                        (col.id === 'axis' && disabledAxisLabel(col.rows)
                            ? ' disabled--text'
                            : '') +
                        ' maxWidthIsADD table-headers' + (col.id === 'axis' && props.isButtonAxisClicked ? ' border-cell' : '') + (col.id === 'add' && props.isButtonAddClicked ? ' border-cell' : '') + (col.id === 'cyl' && props.isButtonCylClicked ? ' border-cell' : '') + (col.id === 'sph' && props.isButtonSphClicked ? ' border-cell' : '')
                    }
                >
                    <div
                        className={
                            'FullPrescriptionForm__innerContainer__form_row mobile-row-headers' +
                            (col.id === 'axis' && disabledAxisLabel(col.rows)
                            ? ' disabled-axis-text'
                            : '')
                        }
                    >
                        {col.name}
                    </div>

                    {col.rows.map(row =>
                        props.selector === 'prescription' ? (
                            <div
                                className={`FullPrescriptionForm__innerContainer__form_row`}
                            >
                                {col.id === 'add' && (
                                    <div className="FullPrescriptionForm__innerContainer__form_select">
                                        <div className="FullPrescriptionForm__innerContainer__form_select_prescription FullPrescriptionForm__innerContainer__form_select_prescription__add">
                                            <select
                                                tabIndex={0}
                                                title={row.id}
                                                name={row.id}
                                                className={`${row.id} ${props.formValues[props.selector][row.id].value > 0 ? '' : ' value-none'}`}
                                                value={
                                                    props.formValues[props.selector][row.id]
                                                        .value || ''
                                                }
                                                onChange={e => {
                                                    let valueToSet =
                                                        col.id === 'baseDirectionVert' ||
                                                        col.id === 'baseDirectionHor'
                                                            ? e.currentTarget.value
                                                            : parseFloat(e.currentTarget.value);
                                                    props.formValues[props.selector][row.id].setter(
                                                        valueToSet
                                                    );
                                                }}
                                            >
                                                {getSimplePrescriptionValuesArray(
                                                    col.min,
                                                    col.max,
                                                    col.res,
                                                    col.id === 'add'
                                                        ? props.selectPlaceholder
                                                        : props.selector === 'prism'
                                                        ? prismSelectPlaceholder
                                                        : null,
                                                    2,
                                                    col.values
                                                ).map((e, key) => {
                                                    return (
                                                        <option key={key} value={e.value}>
                                                            {e.name}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                            {/**TODO Only visible for Costa  */}
                                            <div
                                                className={
                                                    'FullPrescriptionForm__innerContainer__form_select__image'
                                                }
                                            ></div>
                                        </div>
                                    </div>
                                )}
                                {col.id !== 'axis' && col.id !== 'add' && (
                                    <div
                                        className={
                                            'FullPrescriptionForm__innerContainer__form_select_custom'
                                        }
                                    >
                                        <PrescriptionSelect
                                            label={col.name}
                                            name={row.id}
                                            value={props.formValues[props.selector][row.id].value}
                                            onChange={e => {
                                                let valueToSet =
                                                    col.id === 'baseDirectionVert' ||
                                                    col.id === 'baseDirectionHor'
                                                        ? e.currentTarget.value
                                                        : e;
                                                props.formValues[props.selector][row.id].setter(
                                                    valueToSet
                                                );
                                            }}
                                            hasError={
                                                false
                                            }
                                            options={getSimplePrescriptionValuesArray(
                                                col.min,
                                                col.max,
                                                col.res,
                                                col.id === 'add'
                                                    ? props.selectPlaceholder
                                                    : props.selector === 'prism'
                                                    ? prismSelectPlaceholder
                                                    : null,
                                                2,
                                                col.values
                                            ).map((e, key) => {
                                                return (
                                                    <option key={key} value={e.value}>
                                                        {e.name}
                                                    </option>
                                                );
                                            })}
                                        />
                                    </div>
                                )}
                                {col.id === 'axis' && (
                                    <div
                                        className={
                                            'FullPrescriptionForm__innerContainer__form_select'
                                        }
                                    >
                                        <div
                                            className={`FullPrescriptionForm__innerContainer__form_select_prescription${
                                                isAxisDisabled(row.id) ? ' disabled' : ''
                                            }`}
                                        >
                                            {/* <span key={props.formValues[props.selector][row.id].value}> */}
                                            <input
                                                type="number"
                                                min="0"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                name={row.id}
                                                title={row.id}
                                                value={
                                                    props.formValues[props.selector][row.id]
                                                        .value || ''
                                                }
                                                className={`axis_input ${
                                                    isAxisDisabled(row.id) ? ' disabled-axis-text' : ''
                                                } `}
                                                placeholder={
                                                    !!props.formErrors && props.formErrors[row.id]
                                                        ? 'None'
                                                        : 'None'
                                                }
                                                disabled={isAxisDisabled(row.id) ? true : false}
                                                onChange={e => {
                                                    props.formValues[props.selector][row.id].setter(
                                                        parseFloat(e.currentTarget.value)
                                                    );
                                                    /* if (
                            e.relatedTarget &&
                            e.relatedTarget["id"] === "submitButtonId"
                          ) {
                            props.onSubmit(e);
                          } */
                                                }}
                                            />
                                            {/* </span> */}
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div
                                className={`FullPrescriptionForm__innerContainer__form_row`}
                            >
                                <div
                                    className={'FullPrescriptionForm__innerContainer__form_select'}
                                >
                                    <div className="FullPrescriptionForm__innerContainer__form_select_prescription FullPrescriptionForm__innerContainer__form_select_prescription__add">
                                        <select
                                            tabIndex={0}
                                            name={row.id}
                                            title={row.id}
                                            value={
                                                props.formValues[props.selector][row.id].value || ''
                                            }
                                            className={`${row.id} ${props.formValues[props.selector][row.id].value === null || 
                                                (typeof props.formValues[props.selector][row.id].value !== 'string' && isNaN(props.formValues[props.selector][row.id].value)) || 
                                                (typeof props.formValues[props.selector][row.id].value === 'string' && props.formValues[props.selector][row.id].value.length === 0) ? ' value-none' : ''}`}
                                            onChange={e => {
                                                let valueToSet =
                                                    col.id === 'baseDirectionVert' ||
                                                    col.id === 'baseDirectionHor'
                                                        ? e.currentTarget.value
                                                        : parseFloat(e.currentTarget.value);
                                                props.formValues[props.selector][row.id].setter(
                                                    valueToSet
                                                );
                                            }}
                                        >
                                            {getSimplePrescriptionValuesArray(
                                                col.min,
                                                col.max,
                                                col.res,
                                                col.id === 'add'
                                                    ? props.selectPlaceholder
                                                    : props.selector === 'prism'
                                                    ? prismSelectPlaceholder
                                                    : null,
                                                2,
                                                col.values
                                            ).map((e, key) => {
                                                return (
                                                    <option key={key} value={e.value}>
                                                        {e.name}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        )
                    )}
                </div>
            ))}
        </div>
    );
};